import { NetworkName, NetworkWithOrWithoutConfig } from '../types';

export const getNetworkName = (
    network: NetworkWithOrWithoutConfig
): NetworkName => {
    if (typeof network === 'string') return network;
    return Object.keys(network)[0] as NetworkName;
};

export const getNetworkConfig = (
    network: NetworkWithOrWithoutConfig
): object | undefined => {
    if (typeof network === 'string') return undefined;
    return Object.values(network)[0];
};

export const parseNetwork = (network: NetworkWithOrWithoutConfig) => {
    return {
        networkName: getNetworkName(network),
        networkConfig: getNetworkConfig(network),
    };
};
